const needSecondDriverANTT = (group) => {
  if (group.one_driver_exception) return false;
  return group.needs_two_drivers;
};

export { needSecondDriverANTT };
